/* eslint-disable react/jsx-no-target-blank */
import { useFilter } from '../../FilterContext';
import { useParams } from 'react-router-dom';
import clsx from 'clsx';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import { useIntl } from 'react-intl';

interface SelectType {
  readonly value: string;
  readonly label: string;
}

export function ShuftiClientsFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();

  const type: SelectType[] = [
    {
      value: 'SUB_MERCHANT',
      label: intl.formatMessage({ id: 'CLIENTS.TYPE_OPTIONS.SUB_MERCHANT' }),
    },
    {
      value: 'DIRECT_MERCHANT',
      label: intl.formatMessage({ id: 'CLIENTS.TYPE_OPTIONS.DIRECT_MERCHANT' }),
    },
  ];

  const status: SelectType[] = [
    { value: 'PENDING', label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.PENDING' }) },
    { value: 'PROCESSING', label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.PROCESSING' }) },
    { value: 'ACTIVE', label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.ACTIVE' }) },
    { value: 'DELETED', label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.DELETED' }) },
    { value: 'REJECTED', label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.REJECTED' }) },
  ];

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-flex'>
          {/* Type */}
          <MultiSelection
            title={intl.formatMessage({ id: 'CLIENTS.TYPE' })}
            globalFilterValue={globalFilter?.['amlClientList']?.type?.values}
            options={type}
            onChange={(e) => {
              setGlobalFilter({
                ...globalFilter,
                amlClientList: { ...globalFilter.amlClientList, type: { type: 'in', values: e } },
              });
            }}
          />

          {/* Status */}
          <MultiSelection
            title={intl.formatMessage({ id: 'CLIENTS.STATUS' })}
            globalFilterValue={globalFilter?.['amlClientList']?.status?.values}
            options={status}
            onChange={(e) => {
              setGlobalFilter({
                ...globalFilter,
                amlClientList: { ...globalFilter.amlClientList, status: { type: 'in', values: e } },
              });
            }}
          />

          {/* Search */}
          <SearchInputGroup
            inputs={[
              // key = filter key
              { key: 'name', title: intl.formatMessage({ id: 'CLIENTS.CLIENT_NAME' }) },
              { key: 'merchant_id', title: intl.formatMessage({ id: 'CLIENTS.CLIENT_ID' }) },
            ]}
            section='amlClientList' // globalFilter section key
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                amlClientList: { ...globalFilter.amlClientList, ...searchValues },
              })
            }
            onClear={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                amlClientList: { ...globalFilter.amlClientList, ...searchValues },
              })
            }
          />
        </div>
      </div>
    </>
  );
}
